import React from 'react'
import "./banner.css"

function AboutusBanner() {
  return (
    <div>
        <div className='banner'>
            About Us
        </div>
    </div>
  )
}

export default AboutusBanner